import { generateQueryKey } from "../query-factory";
import { queryClient } from "#structure/providers/react-query";
import enterprise from "#resources/api/enterprise-client";

export function useGetZendeskMessagingJwt(): Promise<string> {
	return queryClient.fetchQuery({
		queryKey: generateQueryKey("getZendeskMessagingJwt", undefined),
		queryFn: () => enterprise.getZendeskMessagingJwt({}),
		staleTime: 0,
		retry: false,
	});
}
